import React from "react";
import {
  AssignedTo,
  FormSectionAssignmentConfigBasicDto,
} from "@green0meter/api-client";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { t } from "i18next";
import { isEmpty } from "lodash";

import AssignmentDropdown from "./components/AssignmentDropdown";

import { OpenRow, ParentSelection } from "@components/common/Table";
import { TableColumn } from "@components/common";

export type FormSectionAssignmentConfigRow = FormSectionAssignmentConfigBasicDto & {
  id: string;
};

export const getFormAssignmentColumns = (
  openedRows: OpenRow[],
  selectedSections: ParentSelection[],
  handleToggleSectionDetail: (section: FormSectionAssignmentConfigRow) => void,
  handleGeneralAssignment: (
    value: AssignedTo,
    section: FormSectionAssignmentConfigRow,
  ) => void,
  handleCustomAssignment: (section: FormSectionAssignmentConfigRow) => void,
): TableColumn<FormSectionAssignmentConfigRow>[] => [
  {
    title: t("formAssignment.questionGroup", "Question group"),
    key: "assignedTo",
    dataKey: "name",
    renderCellContent: (section) => {
      const isRowOpened = openedRows.some((row) => row.id === section.id);

      return (
        <Stack direction="row" gap={0.5} alignItems="center">
          <IconButton size="small">
            <FeatherIcon icon={isRowOpened ? "chevron-down" : "chevron-right"} />
          </IconButton>
          <Typography variant="inherit">{section.name}</Typography>
        </Stack>
      );
    },
    onCellClick: (section) => {
      handleToggleSectionDetail(section);
    },
  },
  {
    title: t("formAssignment.generalAssignment", "General assignment"),
    key: "general-assignment",
    tableCellProps: { width: 160, align: "center" },
    renderCellContent: (section) => (
      <AssignmentDropdown
        assignment={{
          assignedTo: section.assignedTo,
        }}
        handleChange={(item) =>
          handleGeneralAssignment(item.value as AssignedTo, section)
        }
        disabled={
          !isEmpty(selectedSections) &&
          !selectedSections.some((s) => s.id === section.id)
        }
      />
    ),
  },
  {
    title: t("formAssignment.customAssignment", "Custom assignment"),
    key: "custom-assignment",
    tableCellProps: { width: 160, align: "center" },
    renderCellContent: (section) => (
      <Button
        variant="outlined"
        onClick={() => handleCustomAssignment(section)}
        size="extraSmall"
        disabled={
          !isEmpty(selectedSections) &&
          !selectedSections.some((s) => s.id === section.id)
        }
      >
        {t("formAssignment.customizeButton", "Customize")}
      </Button>
    ),
  },
];
